import * as React from 'react';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { FormattedMessage } from 'react-intl';
import noDataPic from '../../../../Assets/NoDataBadge.svg';

export const NoDataBadge: React.FC = (): React.ReactElement => {
  return (
    <>
      <Column
        width='100%'
        heights='fill'
        alignmentHorizontal='center'
        minHeight='30vh'
      >
        <Row>
          <img src={noDataPic} alt='No data' />
        </Row>
        <Row>
          <Column>
            <Text type='h100'>
              <FormattedMessage
                id='cs_perfportal_bq_no_data'
                defaultMessage='No associates in this bottom quartile.'
                description='No data to report'
              />
            </Text>
            <Row alignmentHorizontal='center'>
              <Text type='b300'>
                <FormattedMessage
                  id='cs_perfportal_bq_no_data_inspiration'
                  defaultMessage='Keep it up!'
                />
              </Text>
            </Row>
          </Column>
        </Row>
      </Column>
    </>
  );
};
